// extracted by mini-css-extract-plugin
export default {"notFoundCard":"not-found_notFoundCard__kzwK1"};